// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IZendeskMessagingTokenResponseDto
 */
export interface IZendeskMessagingTokenResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IZendeskMessagingTokenResponseDto
     */
    token?: string;
}

/**
 * Check if a given object implements the IZendeskMessagingTokenResponseDto interface.
 */
export function instanceOfIZendeskMessagingTokenResponseDto(value: object): value is IZendeskMessagingTokenResponseDto {
    return true;
}

export function IZendeskMessagingTokenResponseDtoFromJSON(json: any): IZendeskMessagingTokenResponseDto {
    return IZendeskMessagingTokenResponseDtoFromJSONTyped(json, false);
}

export function IZendeskMessagingTokenResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IZendeskMessagingTokenResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'] == null ? undefined : json['token'],
    };
}

export function IZendeskMessagingTokenResponseDtoToJSON(json: any): IZendeskMessagingTokenResponseDto {
    return IZendeskMessagingTokenResponseDtoToJSONTyped(json, false);
}

export function IZendeskMessagingTokenResponseDtoToJSONTyped(value?: IZendeskMessagingTokenResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

